// // import React from 'react';

// // const AimsObjectives = () => {
// //   const primaryColor = "rgb(0, 111, 47)";

// //   const sectionStyle = {
// //     padding: "60px 20px",
// //     maxWidth: "1100px",
// //     margin: "0 auto",
// //     fontFamily: "'Segoe UI', Roboto, sans-serif",
// //     lineHeight: "1.7",
// //     color: "#333"
// //   };

// //   const headerBoxStyle = {
// //     textAlign: "center",
// //     marginBottom: "50px",
// //     padding: "20px"
// //   };

// //   const gridStyle = {
// //     display: "grid",
// //     gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
// //     gap: "25px",
// //     marginTop: "30px"
// //   };

// //   const objectiveCardStyle = {
// //     background: "#fff",
// //     padding: "25px",
// //     borderRadius: "12px",
// //     boxShadow: "0 5px 15px rgba(0,0,0,0.05)",
// //     borderTop: `4px solid ${primaryColor}`,
// //     transition: "transform 0.3s ease"
// //   };

// //   const numberStyle = {
// //     display: "inline-block",
// //     width: "35px",
// //     height: "35px",
// //     background: primaryColor,
// //     color: "#fff",
// //     borderRadius: "50%",
// //     textAlign: "center",
// //     lineHeight: "35px",
// //     fontWeight: "bold",
// //     marginBottom: "15px"
// //   };

// //   return (
// //     <div style={{ paddingTop: "140px", backgroundColor: "#f4f7f4", minHeight: "100vh" }}>
// //       <div style={sectionStyle}>
        
// //         {/* Header Section */}
// //         <div style={headerBoxStyle}>
// //           <h1 style={{ color: primaryColor, fontSize: "2.8rem", fontWeight: "800", marginBottom: "20px" }}>
// //             "Shaping Children. Serving Society."
// //           </h1>
// //           <p style={{ fontSize: "1.2rem", color: "#555", maxWidth: "900px", margin: "0 auto", fontStyle: "italic" }}>
// //             Every decision we make at Delhi Public Kids School is guided by one unwavering belief — that quality education, 
// //             delivered with love and purpose, can change the trajectory of a child's life, and through that child, the world.
// //           </p>
// //         </div>

// //         <h2 style={{ 
// //           textAlign: "center", 
// //           fontSize: "2rem", 
// //           marginBottom: "30px", 
// //           color: "#222",
// //           textTransform: "uppercase",
// //           letterSpacing: "1px"
// //         }}>
// //           Our Objectives
// //         </h2>

// //         {/* Objectives Grid */}
// //         <div style={gridStyle}>
          
// //           {/* Objective 1 */}
// //           <div style={objectiveCardStyle}>
// //             <div style={numberStyle}>1</div>
// //             <h3 style={{ color: primaryColor, marginBottom: "10px" }}>Quality Education, Accessible to All</h3>
// //             <p>Provide quality education to children with minimum financial burden on parents.</p>
// //           </div>

// //           {/* Objective 2 */}
// //           <div style={objectiveCardStyle}>
// //             <div style={numberStyle}>2</div>
// //             <h3 style={{ color: primaryColor, marginBottom: "10px" }}>Holistic Character Building</h3>
// //             <p>Impart ideal education to mould and develop children into good human beings and responsible citizens.</p>
// //           </div>

// //           {/* Objective 3 */}
// //           <div style={objectiveCardStyle}>
// //             <div style={numberStyle}>3</div>
// //             <h3 style={{ color: primaryColor, marginBottom: "10px" }}>Values & Ethics</h3>
// //             <p>Propagate patriotic, social, and ethical values to make children responsible citizens who contribute positively.</p>
// //           </div>

// //           {/* Objective 4 */}
// //           <div style={objectiveCardStyle}>
// //             <div style={numberStyle}>4</div>
// //             <h3 style={{ color: primaryColor, marginBottom: "10px" }}>Complete Growth</h3>
// //             <p>Ensure physical, mental, and moral growth of students, and create in them a lifelong zest for learning.</p>
// //           </div>

// //           {/* Objective 5 */}
// //           <div style={objectiveCardStyle}>
// //             <div style={numberStyle}>5</div>
// //             <h3 style={{ color: primaryColor, marginBottom: "10px" }}>Creative Leisure & Recreation</h3>
// //             <p>Assist children in enjoying leisure through recreational activities—because a child who plays well, learns well.</p>
// //           </div>

// //           {/* Objective 6 */}
// //           <div style={objectiveCardStyle}>
// //             <div style={numberStyle}>6</div>
// //             <h3 style={{ color: primaryColor, marginBottom: "10px" }}>Aesthetic Sense & Hygiene</h3>
// //             <p>Inculcate habits of personal and social hygiene and arouse the aesthetic sense for a happy, healthy life.</p>
// //           </div>

// //           {/* Objective 7 */}
// //           <div style={objectiveCardStyle}>
// //             <div style={numberStyle}>7</div>
// //             <h3 style={{ color: primaryColor, marginBottom: "10px" }}>Teamwork & Leadership</h3>
// //             <p>Broaden the outlook of students through training in co-operation, team spirit, and community service.</p>
// //           </div>

// //           {/* Objective 8 */}
// //           <div style={objectiveCardStyle}>
// //             <div style={numberStyle}>8</div>
// //             <h3 style={{ color: primaryColor, marginBottom: "10px" }}>Channelling Energy Positively</h3>
// //             <p>Properly channelise youthful energies towards creativity—helping every child discover their unique gift.</p>
// //           </div>

// //         </div>

// //         {/* Bottom Call to Action or Note */}
// //         <div style={{ 
// //           marginTop: "60px", 
// //           textAlign: "center", 
// //           padding: "30px", 
// //           background: "#fff", 
// //           borderRadius: "15px",
// //           border: `1px dashed ${primaryColor}` 
// //         }}>
// //           <p style={{ fontSize: "1.1rem", fontWeight: "600", color: primaryColor }}>
// //             "Developing responsible, multi-talented individuals for a better tomorrow."
// //           </p>
// //         </div>

// //       </div>
// //     </div>
// //   );
// // };

// // export default AimsObjectives;

// import React from "react";

// const AimsObjectives = () => {
//   const primaryColor = "rgb(0, 111, 47)";

//   const objectives = [
//     {
//       title: "Quality Education, Accessible to All",
//       text: "Provide quality education to children with minimum financial burden on parents.",
//     },
//     {
//       title: "Holistic Character Building",
//       text: "Impart ideal education to mould and develop children into good human beings and responsible citizens.",
//     },
//     {
//       title: "Values & Ethics",
//       text: "Propagate patriotic, social, and ethical values to make children responsible citizens who contribute positively.",
//     },
//     {
//       title: "Complete Growth",
//       text: "Ensure physical, mental, and moral growth of students, and create in them a lifelong zest for learning.",
//     },
//     {
//       title: "Creative Leisure & Recreation",
//       text: "Assist children in enjoying leisure through recreational activities—because a child who plays well, learns well.",
//     },
//     {
//       title: "Aesthetic Sense & Hygiene",
//       text: "Inculcate habits of personal and social hygiene and arouse the aesthetic sense for a happy, healthy life.",
//     },
//     {
//       title: "Teamwork & Leadership",
//       text: "Broaden the outlook of students through training in co-operation, team spirit, and community service.",
//     },
//     {
//       title: "Channeling Energy Positively",
//       text: "Properly channelise youthful energies towards creativity—helping every child discover their unique gift.",
//     },
//   ];

//   return (
//     <div style={styles.page}>
//       <div style={styles.hero}>
//         <img
//           src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=1600&q=80"
//           alt="school children"
//           style={styles.heroImage}
//         />
//         <div style={styles.heroOverlay} />
//         <div style={styles.heroContent}>
//           <h1 style={styles.heroTitle}>Shaping Children. Serving Society.</h1>
//           <p style={styles.heroText}>
//             Every decision we make at Delhi Public Kids School is guided by one belief — that quality education, delivered with love and purpose, can change a child's life.
//           </p>
//         </div>
//       </div>

//       <div style={styles.section}>
//         <h2 style={styles.heading}>Our Objectives</h2>

//         <div style={styles.grid}>
//           {objectives.map((item, i) => (
//             <div
//               key={i}
//               className="obj-card"
//               style={styles.card}
//             >
//               <div style={styles.number}>{i + 1}</div>
//               <h3 style={styles.cardTitle}>{item.title}</h3>
//               <p style={styles.cardText}>{item.text}</p>
//             </div>
//           ))}
//         </div>

//         <div style={styles.noteBox}>
//           <p style={styles.noteText}>
//             Developing responsible, multi-talented individuals for a better tomorrow.
//           </p>
//         </div>
//       </div>

//       <style>{`
//         .obj-card {
//           transition: transform 0.35s ease, box-shadow 0.35s ease, border-color 0.35s ease;
//           will-change: transform;
//         }

//         .obj-card:hover {
//           transform: translateY(-10px) scale(1.02);
//           box-shadow: 0 18px 35px rgba(0,111,47,0.16);
//           border-color: rgba(0,111,47,0.25);
//         }

//         @media (max-width: 768px) {
//           .obj-grid {
//             grid-template-columns: 1fr !important;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default AimsObjectives;

// const styles = {
//   page: {
//     background: "#f4f7f4",
//     minHeight: "100vh",
//     fontFamily: "'Segoe UI', Roboto, sans-serif",
//     overflowX: "hidden",
//   },
//   hero: {
//     position: "relative",
//     width: "100%",
//     height: "420px",
//     overflow: "hidden",
//   },
//   heroImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//     display: "block",
//   },
//   heroOverlay: {
//     position: "absolute",
//     inset: 0,
//     background: "rgba(0,0,0,0.45)",
//   },
//   heroContent: {
//     position: "absolute",
//     inset: 0,
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     textAlign: "center",
//     padding: "0 20px",
//     color: "#fff",
//   },
//   heroTitle: {
//     fontSize: "2.8rem",
//     fontWeight: 800,
//     marginBottom: "18px",
//     maxWidth: "900px",
//   },
//   heroText: {
//     fontSize: "1.15rem",
//     maxWidth: "900px",
//     opacity: 0.95,
//     lineHeight: 1.8,
//   },
//   section: {
//     padding: "60px 20px 80px",
//     maxWidth: "1100px",
//     margin: "0 auto",
//   },
//   heading: {
//     textAlign: "center",
//     fontSize: "2.1rem",
//     marginBottom: "35px",
//     color: "#222",
//     textTransform: "uppercase",
//     letterSpacing: "1px",
//     fontWeight: 800,
//   },
//   grid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
//     gap: "25px",
//     marginTop: "30px",
//   },
//   card: {
//     background: "#fff",
//     padding: "26px",
//     borderRadius: "16px",
//     boxShadow: "0 8px 22px rgba(0,0,0,0.06)",
//     borderTop: `4px solid ${primaryColor}`,
//     border: "1px solid rgba(0,111,47,0.08)",
//   },
//   number: {
//     display: "inline-flex",
//     width: "38px",
//     height: "38px",
//     background: primaryColor,
//     color: "#fff",
//     borderRadius: "50%",
//     alignItems: "center",
//     justifyContent: "center",
//     fontWeight: "700",
//     marginBottom: "14px",
//   },
//   cardTitle: {
//     color: primaryColor,
//     marginBottom: "10px",
//     fontSize: "1.15rem",
//   },
//   cardText: {
//     color: "#444",
//     fontSize: "0.98rem",
//     lineHeight: 1.75,
//     margin: 0,
//   },
//   noteBox: {
//     marginTop: "60px",
//     textAlign: "center",
//     padding: "26px",
//     background: "#fff",
//     borderRadius: "15px",
//     border: `1px dashed ${primaryColor}`,
//   },
//   noteText: {
//     fontSize: "1.08rem",
//     fontWeight: "600",
//     color: primaryColor,
//     margin: 0,
//   },
// };

import React from "react";

const AimsObjectives = () => {
  const primaryColor = "rgb(0, 111, 47)"; // Define kar diya

  const objectives = [
    {
      title: "Quality Education, Accessible to All",
      text: "Provide quality education to children with minimum financial burden on parents.",
    },
    {
      title: "Holistic Character Building",
      text: "Impart ideal education to mould and develop children into good human beings and responsible citizens.",
    },
    {
      title: "Values & Ethics",
      text: "Propagate patriotic, social, and ethical values to make children responsible citizens who contribute positively.",
    },
    {
      title: "Complete Growth",
      text: "Ensure physical, mental, and moral growth of students, and create in them a lifelong zest for learning.",
    },
    {
      title: "Creative Leisure & Recreation",
      text: "Assist children in enjoying leisure through recreational activities—because a child who plays well, learns well.",
    },
    {
      title: "Aesthetic Sense & Hygiene",
      text: "Inculcate habits of personal and social hygiene and arouse the aesthetic sense for a happy, healthy life.",
    },
    {
      title: "Teamwork & Leadership",
      text: "Broaden the outlook of students through training in co-operation, team spirit, and community service.",
    },
    {
      title: "Channeling Energy Positively",
      text: "Properly channelise youthful energies towards creativity—helping every child discover their unique gift.",
    },
  ];

  return (
    <div style={styles.page}>
      <div style={styles.hero}>
        <img
          src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=1600&q=80"
          alt="school children"
          style={styles.heroImage}
        />
        <div style={styles.heroOverlay} />
        <div style={styles.heroContent}>
          <h1 style={styles.heroTitle}>Shaping Children. Serving Society.</h1>
          <p style={styles.heroText}>
            Every decision we make at Delhi Public Kids School is guided by one belief — that quality education, delivered with love and purpose, can change a child's life.
          </p>
        </div>
      </div>

      <div style={styles.section}>
        <h2 style={styles.heading}>Our Objectives</h2>

        <div style={styles.grid}>
          {objectives.map((item, i) => (
            <div
              key={i}
              className="obj-card"
              style={{
                ...styles.card,
                borderTop: `4px solid ${primaryColor}`,
                border: `1px solid rgba(0,111,47,0.08)`,
              }}
            >
              <div style={{
                ...styles.number,
                background: primaryColor,
              }}>
                {i + 1}
              </div>
              <h3 style={{ ...styles.cardTitle, color: primaryColor }}>{item.title}</h3>
              <p style={styles.cardText}>{item.text}</p>
            </div>
          ))}
        </div>

        <div style={{
          ...styles.noteBox,
          border: `1px dashed ${primaryColor}`,
        }}>
          <p style={{ ...styles.noteText, color: primaryColor }}>
            Developing responsible, multi-talented individuals for a better tomorrow.
          </p>
        </div>
      </div>

      <style>{`
        .obj-card {
          transition: transform 0.35s ease, box-shadow 0.35s ease, border-color 0.35s ease;
          will-change: transform;
        }

        .obj-card:hover {
          transform: translateY(-10px) scale(1.02);
          box-shadow: 0 18px 35px rgba(0,111,47,0.16);
          border-color: rgba(0,111,47,0.25);
        }

        @media (max-width: 768px) {
          .obj-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </div>
  );
};

export default AimsObjectives;
const styles = {
  page: {
    background: "#f4f7f4",
    minHeight: "100vh",
    fontFamily: "sans-serif",
    overflowX: "hidden",
  },

  /* HERO */
  hero: {
    position: "relative",
    width: "100%",
    height: "clamp(220px, 45vw, 420px)", // 🔥 responsive height
    overflow: "hidden",
    marginTop: "clamp(80px, 10vw, 140px)", // 🔥 responsive top spacing
  },

  heroImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },

  heroOverlay: {
    position: "absolute",
    inset: 0,
    background: "rgba(0,0,0,0.45)",
  },

  heroContent: {
    position: "absolute",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: "0 clamp(12px, 4vw, 20px)", // 🔥 mobile safe padding
    color: "#fff",
  },

  heroTitle: {
    fontSize: "clamp(20px, 5vw, 40px)", // 🔥 responsive text
    fontWeight: 800,
    marginBottom: "clamp(10px, 2vw, 18px)",
    maxWidth: "900px",
  },

  heroText: {
    fontSize: "clamp(13px, 2.5vw, 18px)",
    maxWidth: "900px",
    opacity: 0.95,
    lineHeight: 1.8,
  },

  /* SECTION */
  section: {
    padding: "clamp(30px, 6vw, 60px) clamp(12px, 4vw, 20px) clamp(40px, 8vw, 80px)",
    maxWidth: "1100px",
    margin: "0 auto",
  },

  heading: {
    textAlign: "center",
    fontSize: "clamp(18px, 4vw, 32px)",
    marginBottom: "clamp(20px, 4vw, 35px)",
    color: "#222",
    textTransform: "uppercase",
    letterSpacing: "1px",
    fontWeight: 800,
  },

  /* GRID */
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", // 🔥 better mobile fit
    gap: "clamp(15px, 3vw, 25px)",
    marginTop: "30px",
  },

  card: {
    background: "#fff",
    padding: "clamp(18px, 4vw, 26px)",
    borderRadius: "16px",
    boxShadow: "0 8px 22px rgba(0,0,0,0.06)",
    transition: "0.3s ease",
  },

  number: {
    display: "inline-flex",
    width: "clamp(30px, 6vw, 38px)",
    height: "clamp(30px, 6vw, 38px)",
    color: "#fff",
    borderRadius: "50%",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "700",
    marginBottom: "12px",
    fontSize: "clamp(12px, 2vw, 14px)",
  },

  cardTitle: {
    marginBottom: "8px",
    fontSize: "clamp(14px, 2.5vw, 18px)",
    fontWeight: "600",
  },

  cardText: {
    color: "#444",
    fontSize: "clamp(13px, 2vw, 15px)",
    lineHeight: 1.7,
    margin: 0,
  },

  /* NOTE BOX */
  noteBox: {
    marginTop: "clamp(30px, 6vw, 60px)",
    textAlign: "center",
    padding: "clamp(18px, 4vw, 26px)",
    background: "#fff",
    borderRadius: "15px",
  },

  noteText: {
    fontSize: "clamp(14px, 2.5vw, 18px)",
    fontWeight: "600",
    margin: 0,
  },
};
// const styles = {
//   page: {
//     background: "#f4f7f4",
//     minHeight: "100vh",
//     fontFamily: "'Segoe UI', Roboto, sans-serif",
//     overflowX: "hidden",
  
//   },
//   hero: {
//     position: "relative",
//     width: "100%",
//     height: "420px",
//     overflow: "hidden",
//       marginTop:140
//   },
//   heroImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//     display: "block",
//   },
//   heroOverlay: {
//     position: "absolute",
//     inset: 0,
//     background: "rgba(0,0,0,0.45)",
//   },
//   heroContent: {
//     position: "absolute",
//     inset: 0,
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     textAlign: "center",
//     padding: "0 20px",
//     color: "#fff",
//     fontFamily: 'sans-serif',

//   },
//   heroTitle: {
//     fontSize: "2.8rem",
//     fontWeight: 800,
//     marginBottom: "18px",
//     maxWidth: "900px",
//     fontFamily: 'sans-serif',
//   },
//   heroText: {
//     fontSize: "1.15rem",
//     maxWidth: "900px",
//     opacity: 0.95,
//     lineHeight: 1.8,
//     fontFamily: 'sans-serif',
//   },
//   section: {
//     padding: "60px 20px 80px",
//     maxWidth: "1100px",
//     margin: "0 auto",
//   },
//   heading: {
//     textAlign: "center",
//     fontSize: "2.1rem",
//     marginBottom: "35px",
//     color: "#222",
//     textTransform: "uppercase",
//     letterSpacing: "1px",
//     fontWeight: 800,
//     fontFamily: 'sans-serif',
//   },
//   grid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
//     gap: "25px",
//     marginTop: "30px",
//   },
//   card: {
//     background: "#fff",
//     padding: "26px",
//     borderRadius: "16px",
//     boxShadow: "0 8px 22px rgba(0,0,0,0.06)",
//     transition: "0.35s ease",
//   },
//   number: {
//     display: "inline-flex",
//     width: "38px",
//     height: "38px",
//     color: "#fff",
//     borderRadius: "50%",
//     alignItems: "center",
//     justifyContent: "center",
//     fontWeight: "700",
//     marginBottom: "14px",
//     fontFamily: 'sans-serif',
//   },
//   cardTitle: {
//     marginBottom: "10px",
//     fontSize: "1.15rem",
//     fontFamily: 'sans-serif',
//   },
//   cardText: {
//     color: "#444",
//     fontSize: "0.98rem",
//     lineHeight: 1.75,
//     margin: 0,
//     fontFamily: 'sans-serif',
//   },
//   noteBox: {
//     marginTop: "60px",
//     textAlign: "center",
//     padding: "26px",
//     background: "#fff",
//     borderRadius: "15px",
//   },
//   noteText: {
//     fontSize: "1.08rem",
//     fontWeight: "600",
//     margin: 0,
//     fontFamily: 'sans-serif',
//   },
// };